import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';

export default function Privacy() {
  const { t } = useTranslation('privacy');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <Shield className="w-12 h-12 mx-auto text-blue-500 mb-4" />
        <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('title')}</h1>
        <p className="text-lg text-gray-600">{t('subtitle')}</p>
      </div>

      <div className="prose prose-blue max-w-none">
        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('dataCollection.title')}</h2>
          <p className="text-gray-600 mb-4">{t('dataCollection.intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>{t('dataCollection.points.storage')}</li>
            <li>{t('dataCollection.points.encryption')}</li>
            <li>{t('dataCollection.points.ip')}</li>
            <li>{t('dataCollection.points.personal')}</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookies.title')}</h2>
          <p className="text-gray-600 mb-4">{t('cookies.intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>{t('cookies.points.essential')}</li>
            <li>{t('cookies.points.analytics')}</li>
            <li>{t('cookies.points.advertising')}</li>
            <li>{t('cookies.points.preferences')}</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('security.title')}</h2>
          <p className="text-gray-600 mb-4">{t('security.intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>{t('security.points.encryption')}</li>
            <li>{t('security.points.deletion')}</li>
            <li>{t('security.points.rateLimit')}</li>
            <li>{t('security.points.audits')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('contact.title')}</h2>
          <p className="text-gray-600">{t('contact.message')}</p>
        </section>
      </div>
    </div>
  );
}